import "./Services.module.css";
import MainNavigation from "@/reusable_sections/Header";
import OurStrategicPillars from "./sections/OurStrategicPillars";
import TheRevbabaProcess from "./sections/TheRevbabaProcess";
import FooterInformation from "@/reusable_sections/Footer";
import Faq from "./sections/Faq";
import CaseStudies from "./sections/CaseStudies";
export default function ServicesPage() {
  return <div>
      <MainNavigation />
      <OurStrategicPillars />
      <TheRevbabaProcess />
      <CaseStudies />
      <Faq />
      <FooterInformation />
    </div>;
}